"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RDPResponseStateType = exports.RDPResponseType = exports.RDPRequestType = void 0;
var RDPRequestType;
(function (RDPRequestType) {
    RDPRequestType["Close"] = "Close";
    RDPRequestType["Auth"] = "Auth";
    RDPRequestType["Subscribe"] = "Subscribe";
    RDPRequestType["Push"] = "Push";
    RDPRequestType["Modify"] = "Modify";
})(RDPRequestType || (exports.RDPRequestType = RDPRequestType = {}));
var RDPResponseType;
(function (RDPResponseType) {
    RDPResponseType["Response"] = "Response";
    RDPResponseType["Update"] = "Update";
    RDPResponseType["Ack"] = "Ack";
    RDPResponseType["Alarm"] = "Alarm";
})(RDPResponseType || (exports.RDPResponseType = RDPResponseType = {}));
var RDPResponseStateType;
(function (RDPResponseStateType) {
    RDPResponseStateType["Open"] = "Open";
    RDPResponseStateType["Closed"] = "Closed";
    RDPResponseStateType["ClosedRecover"] = "ClosedRecover";
    RDPResponseStateType["NonStreaming"] = "NonStreaming";
    RDPResponseStateType["Redirected"] = "Redirected";
})(RDPResponseStateType || (exports.RDPResponseStateType = RDPResponseStateType = {}));
